"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useModal;
var _react = require("react");
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _size = _interopRequireDefault(require("lodash/fp/size"));
var _dom = require("@active/react-utils/dom");
var _scrollHelper = _interopRequireDefault(require("@active/react-utils/dom/scrollHelper"));
var _scopedFocus = _interopRequireDefault(require("@active/react-utils/dom/scopedFocus"));
var _eventHandler = require("@active/react-utils/eventHandler");
var _useFocusFinalElement = require("@active/react-utils/dom/useFocusFinalElement");
var _constants = require("../constants");
var isFocusable = function isFocusable(selector) {
  return (0, _compose["default"])(selector, (0, _dom.tabbable)({
    displayCheck: 'none'
  }));
};
function useModal(_ref) {
  var shown = _ref.shown,
    onClose = _ref.onClose,
    clickEscape = _ref.clickEscape,
    clickEscapeExceptionRefs = _ref.clickEscapeExceptionRefs,
    finalFocusRef = _ref.finalFocusRef,
    rootRef = _ref.rootRef;
  var scroll = (0, _react.useMemo)(function () {
    return new _scrollHelper["default"]();
  }, []);
  var previousShown = (0, _react.useRef)(false);
  (0, _react.useEffect)(function handleLockScroll() {
    if (shown) {
      scroll.lockScroll();
    }
    return function () {
      shown && scroll.unlockScroll();
    };
  }, [shown, scroll]);
  (0, _react.useEffect)(function handleClickEscape() {
    if (clickEscape) {
      return (0, _eventHandler.listenClickEscape)(onClose, clickEscapeExceptionRefs);
    }
    return undefined;
  }, [shown, onClose, clickEscape, clickEscapeExceptionRefs]);
  (0, _useFocusFinalElement.useFocusFinalElement)({
    finalFocusRef: finalFocusRef,
    when: previousShown.current && !shown
  });
  (0, _react.useEffect)(function updatePreviousProps() {
    previousShown.current = shown;
  });
  var handleKeydown = (0, _react.useCallback)(function (e) {
    if (shown) {
      var scopedFocusRoot = rootRef.current;
      switch (e.key) {
        case _constants.KEY_VALUES.TAB:
          if (scopedFocusRoot && isFocusable(_size["default"])(scopedFocusRoot)) {
            e.preventDefault();
            (0, _scopedFocus["default"])(scopedFocusRoot, {
              direction: e.shiftKey ? 'previous' : 'next',
              circular: true
            });
          } else {
            onClose();
          }
          break;
        case _constants.KEY_VALUES.ESCAPE:
          onClose === null || onClose === void 0 || onClose();
          e.stopPropagation();
          break;
        default:
          break;
      }
    }
  }, [rootRef, shown, onClose]);
  return {
    handleKeydown: handleKeydown
  };
}